// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__P+9mm","page":"pagination_page__MtB+3","page_active":"pagination_page_active__Ddb+e","page_small":"pagination_page_small__XlgR+"};